import React from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export default function LinkButton(props) {
  return (
    <Link
      {...props}
      className={twMerge(
        "px-8 py-2 rounded font-semibold text-center bg-violet-500 focus:outline-none focus:ring focus:ring-offset-2 focus:ring-violet-500 focus:ring-opacity-80 cursor-pointer flex justify-center items-center gap-3",
        props.className
      )}
    />
  );
}
